<div
  class="screen-container"
  [ngStyle]="{ 'padding-top': (showMenuBar$ | async) ? '64px' : '0', 'max-width': (showMenuBar$ | async) ? '1920px' : 'initial' }"
>
  <ng-container *ngIf="showMenuBar$ | async">
    <osn-cxb-menu-bar></osn-cxb-menu-bar>
    <div class="container-fluid mt-3 mb-3">
      <osn-cxb-notification></osn-cxb-notification>
    </div>
  </ng-container>
  <div class="fullscreen-loader" *ngIf="isLoading" data-testid="full-screen-loader-testid"></div>
  <div class="d-flex w-100 flex-fill">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    <router-outlet *ngIf="!isIframe"></router-outlet>
  </div>
</div>
